export const SHORT_DAYS_NAMES = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
export const DAYS_NAMES = [
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
  "Воскресенье",
];
export const MONTHS = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];
export const COUNT_IN_ROW = {
  days: 7,
  months: 3,
  years: 4,
};
export const ARROWS = {
  ArrowRight: "ArrowRight",
  ArrowLeft: "ArrowLeft",
  ArrowUp: "ArrowUp",
  ArrowDown: "ArrowDown",
} as const;
export const NAVIGATION_STATES = ["days", "months", "years"] as const;
export const YEARS_LIST_INTERVAL = 20;
export const WEEKS_COUNT_IN_TABLE = 6;
export const NAVIGATION_KINDS = {
  right: {
    days: "Следующий месяц",
    months: "Следующий год",
    years: "Следующие 20 лет",
  },
  left: {
    days: "Предыдущий месяц",
    months: "Предыдущий год",
    years: "Предыдущие 20 лет",
  },
};
export const NEXT_CALENDAR_TYPE = {
  days: "Перейти к выбору месяца",
  months: "Перейти к выбору года",
  years: "",
};
export const CALENDAR_NAVIGATION_ID = "calendar-navigation";
export const KEYS = {
  TAB: "Tab",
  HOME: "Home",
  END: "End",
  PAGE_UP: "PageUp",
  PAGE_DOWN: "PageDown",
};
